import React from "react";

const ShieldIcon = (props) => {
  const { isActive, ...rest } = props;
  const fill = isActive ? "#00BC35" : "#999";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_235_338)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6475 0.0759693C11.8717 -0.0253231 12.1288 -0.0253231 12.353 0.0759693C16.6145 2.00053 18.5275 2.61543 23.2462 3.46186C23.6348 3.53156 23.9255 3.8576 23.9503 4.25156C24.8562 18.6094 13.2043 23.582 12.3205 23.9379C12.115 24.0207 11.8855 24.0207 11.68 23.9379C10.7962 23.582 -0.855728 18.6094 0.0501654 4.25156C0.0750221 3.8576 0.365725 3.53156 0.75427 3.46186C5.47296 2.61543 7.38596 2.00053 11.6475 0.0759693ZM1.72841 5.02675C1.32426 16.721 10.09 21.3433 12.0002 22.2096C13.9105 21.3433 22.6762 16.721 22.2721 5.02675C18.0079 4.23514 15.9454 3.56473 12.0002 1.79703C8.05514 3.56473 5.9926 4.23514 1.72841 5.02675Z"
          fill={rest.fill || fill}
        />
        <path
          d="M11.9999 0.857147C7.67618 2.80983 5.69564 3.44625 0.905284 4.30554C0.0374272 18.0605 11.1739 22.8102 11.9999 23.1429V0.857147Z"
          fill={rest.fill || fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_235_338">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ShieldIcon;
